import { AlertTriangle } from "lucide-react";

export function DevStoreBanner() {

  const handleUpgrade = () => {
   window.open("https://apps.shopify.com/reveshare", "_blank");
  };

  return (
    <div className="w-full bg-amber-50 border-b border-amber-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between gap-3 py-1.5">
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <AlertTriangle className="h-3.5 w-3.5 text-amber-600 flex-shrink-0" />
            <p className="text-xs font-medium text-amber-800 truncate">
              You're using a dev store. Upgrade to use Reveshare in your shops.
            </p>
          </div>
          <button
            onClick={handleUpgrade}
            className="flex-shrink-0 px-3 py-1 text-xs font-semibold text-amber-900 bg-amber-200 hover:bg-amber-300 rounded-md transition-colors duration-200 whitespace-nowrap"
          >
            Install Now
          </button>
        </div>
      </div>
    </div>
  );
}
